export const MatchesHeaderTable = [
  'matchType',
  'scoreType',
  'event',
  'date',
  'playerA1DuprId',
  'playerA2DuprId',
  'playerB1DuprId',
  'playerB2DuprId',
  'teamAGame1',
  'teamBGame1',
  'teamAGame2',
  'teamBGame2',
  'teamAGame3',
  'teamBGame3',
  'teamAGame4',
  'teamBGame4',
  'teamAGame5',
  'teamBGame5'
];
